// extracted by mini-css-extract-plugin
export var modalFooter = "_ms-0";